<template>
  <div class="g-content">
    <div class="attach-main">
      <!-- 左侧文件夹列表 -->
      <div class="attach-side">
        <div class="attach-side-content">
          <!-- 搜索 -->
          <div class="attach-side-search">
            <!-- input -->
            <a-input-search
              v-model="searchFolder"
              :placeholder="$t('attach_form_folder_search_placeholder')"
              allowClear
              @change="onLeftChange"
              size="large"
            />

            <!-- +号 -->
            <span v-if="AUTH_ATTACH_DIR_ADD || AUTH_ATTACH_FILE_UPLOAD">
              <a-dropdown :trigger="['click']">
                <Icon type="add" />
                <template #overlay>
                  <a-menu class="context-menu" @click="handleMenuClick">
                    <!-- 新建文件夹 -->
                    <a-menu-item key="newFolder" v-if="AUTH_ATTACH_DIR_ADD">
                      {{ $t('attach_menu_new_folder') }}
                    </a-menu-item>
                    <a-menu-item key="upload" v-if="AUTH_ATTACH_FILE_UPLOAD">
                      {{ $t('attach_menu_upload') }}
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </span>
          </div>
          <div class="attach-side-menu">
            <a-directory-tree
              multiple
              blockNode
              :defaultExpandAll="false"
              @select="onSelect"
              :tree-data="treeData"
              :showIcon="false"
              :expandAction="false"
              v-if="treeData && treeData.length"
            />
            <Empty v-else />
          </div>
        </div>
      </div>

      <!-- 右侧列表 -->
      <div class="attach-list">
        <!-- 搜索 -->
        <div class="attach-filter">
          <div class="attach-filter-main">
            <div class="attach-filter-search">
              <a-input-search
                v-model="query.keyword"
                :placeholder="$t('attach_form_file_search_placeholder')"
                @search="onSearch"
                @change="onChange"
                size="large"
                allowClear
                type="default"
              >
                <a-button slot="enterButton" class="attach-filter-search-current" v-if="false">
                  {{ $t('com_btn_search_folder') }}
                </a-button>
              </a-input-search>
              <a-button
                type="primary"
                @click="onGlobalSearch"
                size="large"
                class="attach-filter-search-global"
              >
                {{ $t('com_btn_search_global') }}
              </a-button>
            </div>
            <a-button type="primary" @click="getData" size="large" class="attach-refresh">
              <Icon type="refresh" />
            </a-button>
          </div>
        </div>

        <!-- 列表 -->
        <div class="attach-list-content">
          <Loading :show="true" v-if="loading" />
          <a-table
            :columns="columns"
            :data-source="list"
            bordered
            :rowKey="(_text, index) => index"
            :pagination="false"
            :loading="tableLoading"
            @change="handleTableSort"
            v-else
          >
            <template slot="name" slot-scope="name, record">
              <!-- 鼠标移到名称上超过2秒显示简要介绍 -->
              <a-popover placement="top" title="" trigger="hover">
                <template slot="content">
                  <div class="tree-intro">
                    <h5 :class="{ 'tree-intro-title': record.intro }">{{ name }}</h5>
                    <div class="tree-intro-content" v-if="record.intro">
                      {{ record.intro }}
                    </div>
                  </div>
                </template>

                <div class="attach-name">
                  <Icon :type="fileIcons(name)" />
                  <p>
                    <span
                      v-for="(part, index) in highlightKeyword(name, query.keyword)"
                      :key="index"
                      :class="part.isKeyword ? 'highlight' : ''"
                    >
                      {{ part.text }}
                    </span>
                  </p>
                </div>
              </a-popover>

              <!-- <a-tooltip placement="top" :mouseEnterDelay="2">
                <template #title>
                  <span>{{ record.intro }}</span>
                </template>
                <span
                  v-for="(part, index) in highlightKeyword(name, query.keyword)"
                  :key="index"
                  :class="part.isKeyword ? 'highlight' : ''"
                  >{{ part.text }}</span
                >
              </a-tooltip> -->
            </template>

            <!-- 大小 -->
            <template slot="size" slot-scope="size">
              {{ size | formatSize }}
            </template>

            <!-- 创建人 -->
            <template slot="createUserName" slot-scope="name">
              <span
                v-for="(part, index) in highlightKeyword(name, query.keyword)"
                :key="index"
                :class="part.isKeyword ? 'highlight' : ''"
                >{{ part.text }}</span
              >
            </template>

            <!-- 创建时间  -->
            <template slot="createTime" slot-scope="date">
              {{ date | formatDate('yyyy-MM-dd HH:mm:ss') }}
            </template>

            <!-- 操作栏 -->
            <template slot="Action" slot-scope="text, record">
              <div class="attach-list-action">
                <!-- 分享 -->
                <a-button
                  type="primary"
                  @click="handleShare(record)"
                  class="g-btn-icon"
                  v-if="AUTH_ATTACH_SHARE && hasWritePermissioin(record)"
                >
                  <Icon type="share" />
                </a-button>

                <!-- 编辑 -->
                <a-button
                  type="primary"
                  @click="editAttach(record)"
                  class="g-btn-icon"
                  v-if="AUTH_ATTACH_FILE_EDIT && hasWritePermissioin(record)"
                >
                  <Icon type="edit" />
                </a-button>

                <!-- 下载 -->
                <a-button
                  type="primary"
                  @click="downloadAttach(record)"
                  class="g-btn-icon"
                  v-if="hasReadPermissioin(record)"
                >
                  <Icon type="download" />
                </a-button>

                <!-- 删除 -->
                <a-button
                  type="red"
                  @click="deleteAttachFile($event, record)"
                  class="g-btn-icon"
                  v-if="AUTH_ATTACH_FILE_DELETE && hasWritePermissioin(record)"
                >
                  <Icon type="delete" />
                </a-button>
              </div>
            </template>
          </a-table>

          <div class="device-pagination">
            <Pagination
              :current.sync="pagination.current"
              :total="pagination.total"
              :pageSize.sync="pagination.pageSize"
              :callback="pageChange"
              @change="pageChange"
              show-quick-jumper
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 创建文件夹 -->
    <FolderDialog ref="newFolderDialog" @submit="handleFolder" />

    <!-- 上传文件 -->
    <AttachDialog
      ref="uploadDialog"
      :tree-data="allTreeDataArray"
      :node-data="currentNode"
      @callback="uploadCallback"
    />

    <!-- 重全名 -->
    <RenameDialog ref="renameDialog" @success="getTreeData" />

    <!-- 分享 -->
    <ShareDialog ref="shareDialog" />
  </div>
</template>
<script>
import * as API from '@/api/attach';
import FolderDialog from './components/FolderDialog.vue';
import AttachDialog from './components/AttachDialog.vue';
import RenameDialog from './components/RenameDialog.vue';
import ShareDialog from './components/ShareDialog.vue';
import TreeNodeTitle from './components/TreeNodeTitle.vue';
import attachAuth from '@/views/attach/mixins/attachAuth';
import attachConfig from '@/views/attach/mixins/config';
import { downloadFile } from '@/config/oss';
import { makeTree } from '@/libs/utils';
import { mapState } from 'vuex';
import { hasReadWritePermission } from '@/libs/permissions';
import fileIcons from '@/config/fileIcons';

export default {
  mixins: [attachAuth, attachConfig],
  components: {
    FolderDialog,
    AttachDialog,
    RenameDialog,
    ShareDialog,
  },
  data() {
    return {
      fileIcons,
      loading: true,
      tableLoading: false,
      columns: [
        {
          title: '#',
          align: 'center',
          customRender: (text, record, index) => {
            return (this.pagination.current - 1) * this.pagination.pageSize + (index + 1);
          },
        },
        {
          title: this.$t('attach_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          sorter: true,
        },
        {
          title: this.$t('attach_table_size'),
          dataIndex: 'size',
          scopedSlots: { customRender: 'size' },
        },

        {
          title: this.$t('attach_form_type'),
          dataIndex: 'type',
          customRender: text => {
            return this.attachTypeList.find(item => item.value === text)?.label || '--';
          },
        },

        {
          title: this.$t('attach_table_permissions_read'),
          dataIndex: 'readLevel',
          scopedSlots: { customRender: 'readLevel' },
        },

        {
          title: this.$t('attach_table_permissions_write'),
          dataIndex: 'writeLevel',
          scopedSlots: { customRender: 'writeLevel' },
        },
        {
          title: this.$t('attach_table_create_user'),
          dataIndex: 'createUserName',
          scopedSlots: { customRender: 'createUserName' },
        },
        {
          title: this.$t('attach_table_create_time'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          sorter: true,
        },
      ],
      list: [],
      searchFolder: '',
      query: {
        dirId: 0,
        keyword: '',
        type: null,
        date: null,
        orderField: 2,
        orderType: 1,
      },
      // 当前选中目录
      currentNode: {},
      // 用于目录树渲染的数据
      treeData: [],
      // 接口返回的原始数据
      rawTreeData: [],
      allTreeData: [],
      allTreeDataArray: [],
      rootFolder: {
        writeLevel: 0,
        id: 0,
        name: this.$t('attach_root_folder'),
        readLevel: 0,
        type: 1,
        root: true,
      },

      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },
      searchTimer: null,
    };
  },
  computed: {
    ...mapState(['userInfo', 'authList']),
  },

  created() {
    this.getData();

    // 权限
    if (this.AUTH_ATTACH_SHARE || this.AUTH_ATTACH_FILE_EDIT || this.AUTH_ATTACH_FILE_DELETE) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        scopedSlots: { customRender: 'Action' },
      });
    }

    // 初始
  },
  methods: {
    // 是否有读取权限（读和下载）
    hasReadPermissioin(record) {
      return hasReadWritePermission('read', 'wiki', record.readLevel);
    },

    // 是否有编辑/下载权限
    hasWritePermissioin(record) {
      return hasReadWritePermission('write', 'wiki', record.writeLevel);
    },

    // 排序
    handleTableSort(pag, filters, sorter) {
      const { field, order } = sorter;
      // orderField:"排序字段，为null或者0表示默认按主键排序，1按按照附件名称；2按上传时间排序",
      // orderType:"排序类型, 0为升序，1为倒序",
      if (field === 'name') {
        this.query.orderField = 1;
      } else if (field === 'createTime') {
        this.query.orderField = 2;
      }
      this.query.orderType = order === 'ascend' ? 0 : 1;
      this.getList();
    },

    // 树节点选择事件处理
    onSelect(keys, event) {
      this.currentNode = event.selectedNodes[0]?.dataRef.raw || {};
      this.query.dirId = Number(keys[0]);

      this.treeData = this.formatTreeData([this.rootFolder, ...this.allTreeData.array]);

      // this.searchFolder = '';

      console.log('currentNode', this.currentNode);

      this.getList();
    },

    // 左侧目录 重命名
    handleRename() {
      this.$refs.renameDialog.show(this.currentNode);
    },

    // 获取目录树数据
    getTreeData() {
      return API.getAttachmentTree({ dirId: 0 }).then(res => {
        if (res.code === 0) {
          // 排序
          this.rawTreeData = res.data || [];
          this.allTreeData = makeTree({ data: this.rawTreeData });
          this.allTreeDataArray = [
            // 虚拟的根目录不允许上传文件
            // {
            //   key: `${this.rootFolder.id}`,
            //   label: this.rootFolder.name,
            //   name: this.rootFolder.name,
            //   id: this.rootFolder.id,
            //   value: 0,
            // },
            ...this.allTreeData.array,
          ];

          this.treeData = this.formatTreeData([this.rootFolder, ...this.allTreeData.array]);
        }
      });
    },

    // 格式化树形数据
    formatTreeData(data) {
      let _data = data || this.allTreeData.array;

      _data = _data.map(item => ({
        name: item.name,
        title: this.$createElement(TreeNodeTitle, {
          props: {
            title: item.name,
            record: item,
            dirId: this.query.dirId,
          },
          on: {
            command: item => {
              this.handleMenuCommand(item);
            },
          },
        }),
        key: item.id,
        children: item.children ? this.formatTreeData(item.children) : undefined,
        // 保存原始数据用于其他操作
        raw: item,
      }));

      return _data;
    },

    // 打开第一目录
    openRootFolder() {
      // 默认打开所有文件
      document.getElementById('attachRootFolder').click();
    },

    // 获取初始数据
    getData() {
      const _list = [this.getList(), this.getTreeData()];
      Promise.all(_list).finally(() => {
        this.$store.commit('setPageLoading', false);

        this.openRootFolder();
      });
    },

    // 获取文件列表数据
    getList() {
      this.tableLoading = true;

      // 参数
      const params = {
        ...this.query,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };

      if (!params.keyword) {
        delete params.keyword;
      }

      return API.searchFilesAndFolders(params)
        .then(res => {
          if (res.code === 0) {
            const _data = res.data || [];

            // 右侧数据，过滤掉文件夹
            this.list = _data.filter(item => item.dir !== true);
            this.pagination.total = res.totalCount;
          }
        })
        .finally(() => {
          this.loading = false;
          this.tableLoading = false;
        });
    },

    onLeftChange(e) {
      const value = e.target.value;
      const filterData = this.rawTreeData.filter(item => item.name.includes(value));

      const _data = makeTree({ data: filterData });
      this.treeData = this.formatTreeData([this.rootFolder, ..._data.array]);
    },

    onChange() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.onSearch();
      }, 400);
    },

    onSearch() {
      this.pagination.current = 1;
      this.getList();
    },

    onGlobalSearch() {
      this.pagination.current = 1;
      this.query.dirId = 0;
      this.openRootFolder();
      this.getList();
    },

    // 删除文件夹
    deleteDir(_$event, record) {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('attach_confirm_delete_dir_title'),
        content: h('div', {}, [
          h('p', this.$t('attach_confirm_delete_dir_content', { name: record.name })),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.deleteDirectoryNonCascade({ dirId: record.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getTreeData();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 删除附件
    deleteAttachFile(_$event, attach) {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('attach_confirm_delete_attach_title'),
        content: h('div', {}, [
          h('p', this.$t('attach_confirm_delete_attach_content', { name: attach.name })),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.deleteAttachmentFile({ id: attach.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getList(this.pagination.pageNo);
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 文件夹菜单命令处理
    handleMenuCommand({ command, data }) {
      console.log('command', command, data);
      switch (command) {
        case 'newFolder':
          this.addFolder();
          break;
        case 'editFolder':
          this.editFolder(data);
          break;
        case 'upload':
          this.uploadAttach();
          break;
        case 'rename':
          this.handleRename();
          break;
        case 'delete':
          this.handleDeleteDir();
          break;
      }
    },

    // 新建文件夹
    addFolder() {
      this.$refs.newFolderDialog.show();
    },

    // 编辑文件夹
    editFolder(data) {
      this.$refs.newFolderDialog.show(data);
    },

    // 上传
    uploadAttach() {
      this.$refs.uploadDialog.show(null, true);
    },

    // 编辑附件
    editAttach(record) {
      this.$refs.uploadDialog.show(record, false);
    },

    // 新增、编辑文件夹 保存
    handleFolder(formData) {
      const isEdit = !!formData.id;
      const api = isEdit ? API.editDirectory : API.addDirectory;
      const successMsg = isEdit
        ? this.$t('attach_edit_folder_success')
        : this.$t('attach_create_folder_success');

      api({
        ...formData,
        id: !isEdit ? this.currentNode?.id : formData.id || undefined,
      })
        .then(res => {
          if (res.code === 0) {
            this.$message.success(successMsg);
            this.$refs.newFolderDialog.handleCancel();
            // 刷新列表和树
            this.getList();
            this.getTreeData();
          }
        })
        .finally(() => {
          this.$refs.newFolderDialog.loading = false;
        });
    },

    // 列表分享
    handleShare(record) {
      this.$refs.shareDialog.show(record);
    },

    // 左侧目录 删除操作
    handleDeleteDir() {
      this.deleteDir(null, this.currentNode);
    },

    // 列表 下载附件
    downloadAttach(record) {
      this.$confirm({
        title: this.$t('attach_download_confirm'),
        content: record.name,
        centered: true,
        onOk: () => {
          downloadFile(record.url);
        },
      });
    },

    handleMenuClick({ key }) {
      this.handleMenuCommand({
        command: key,
        target: this.currentNode,
      });
    },

    // 高亮搜索关键字
    highlightKeyword(text, keyword) {
      if (!keyword) {
        return [
          {
            text: text,
            isKeyword: false,
          },
        ];
      }
      const regex = new RegExp(`(${keyword})`, 'gi'); // 匹配关键字，忽略大小写
      const parts = text.split(regex); // 分割文本
      const newParts = [];
      parts.forEach(part => {
        const _part = {
          text: part,
          isKeyword: regex.test(part),
        };
        newParts.push(_part);
      });
      return newParts;
    },

    // 上传成功回调
    uploadCallback(success) {
      if (success) {
        this.getList();
      }
    },

    // 分页
    pageChange(value) {
      this.pagination.current = value;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.tree-intro {
  max-width: 360px;
  word-wrap: break-word;
  word-break: break-all;

  .tree-intro-content {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }

  h5 {
    padding: 0;
    font-weight: bold;
    font-size: 16px;
    padding-top: 10px;

    &.tree-intro-title {
      border-bottom: #e8e8e8 solid 1px;
      padding-bottom: 5px;
      margin-bottom: 10px;
    }
  }
}

.attach-main {
  display: flex;
  height: 100%;
  align-items: stretch;
  justify-content: space-between;
  background: @g-layout-background;

  .attach-side {
    width: 320px;
    height: 100%;
    background-color: @g-layout-background;

    .attach-side-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      background: #fff;
      margin-right: 16px;
      border-radius: 12px;
      min-width: 300px;
      overflow-y: auto;
      // 搜索
      .attach-side-search {
        padding: 24px 24px 5px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 12px;

        > span {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          svg {
            width: 36px;
            height: 36px;
          }
        }
      }

      ::v-deep .attach-side-menu {
        padding: 16px 24px 0 5px;
        box-sizing: border-box;

        .ant-tree-directory {
          display: flex;
          align-items: flex-start;
          flex-direction: column;

          li {
            border-radius: 6px;
            width: 100%;
            padding: 0;
            margin: 0 0 5px 0;
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            span {
              &.ant-tree-switcher {
                padding: 24px 0;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                color: #000;
              }

              &.ant-tree-node-content-wrapper {
                display: flex;
                flex: 1;
                height: 100%;
                border-radius: 6px;
                align-items: center;

                span {
                  &.ant-tree-iconEle {
                    color: #000;
                  }

                  &.ant-tree-title {
                    color: #000;
                    font-size: 16px;
                    white-space: normal;
                    word-wrap: break-word;
                    word-break: break-all;
                    width: 100%;
                    padding: 10px 0;
                    z-index: 1;
                  }
                }

                &::before {
                  background: none;
                  color: #000;
                }

                &:hover {
                  background: #f3f3f3;
                }
              }
            }
            // 鼠标悬浮
            &.ant-tree-node-content-wrapper:hover {
              background: #f3f3f3;
            }

            // 选中
            &.ant-tree-treenode-selected {
              > span {
                &.ant-tree-switcher {
                  color: #1838d9;
                }
                &.ant-tree-node-content-wrapper {
                  background: #e6e7f8;
                  display: flex;
                  flex: 1;

                  .ant-tree-iconEle {
                    .anticon {
                      color: #1838d9 !important;
                    }
                  }

                  .ant-tree-title {
                    color: #1838d9;
                    // font-weight: bold;
                    &:hover {
                      background: #e6e7f8;
                    }
                  }

                  &::before {
                    background: none;
                    color: #1838d9;
                  }
                  // 选中时鼠标经过
                  &:hover {
                    background: #e6e7f8;
                    .ant-tree-iconEle,
                    .ant-tree-title {
                      background: #e6e7f8;
                    }
                  }
                }
              }
            }

            // 子元素
            .ant-tree-child-tree {
              flex-basis: 100%; /* 让 ul 占据整行 */
              margin-top: 8px; /* 与上方的内容保持间距 */
            }
          }
        }
      }
    }
  }

  // 列表
  .attach-list {
    flex: 1;
    height: 100%;
    border-radius: 12px;
    background: #fff;

    // 过滤
    .attach-filter {
      background: @g-layout-background;
      padding-bottom: 16px;

      .attach-filter-main {
        padding: 12px 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        background: #fff;
        border-radius: 12px;

        .attach-filter-search {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 50%;

          .attach-filter-search-current {
            background: #eee;

            &:hover {
              background: rgba(24, 56, 217, 0.1);
              border-color: #ddd;
            }
          }

          .attach-filter-search-global {
            margin-left: 10px;
          }
        }

        .attach-refresh {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    // 列表
    .attach-list-content {
      padding: 24px;
      box-shadow: 0 -12px 0 0 @g-layout-background;
      border-radius: 12px;
      height: calc(100% - 60px);
      overflow-y: auto;
      .attach-list-action {
        display: flex;
        align-items: center;
        gap: 16px;
        justify-content: center;
      }

      .attach-name {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 5px;

        svg {
          width: 20px;
          height: 20px;
        }

        p {
          margin: 0;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex: 1;
        }
      }
    }

    .highlight {
      color: #1838d9 !important;
      font-weight: bold !important;
    }
  }
}
</style>
